import { render, staticRenderFns } from "./miniapp.vue?vue&type=template&id=9c06432c&"
import script from "./miniapp.vue?vue&type=script&lang=js&"
export * from "./miniapp.vue?vue&type=script&lang=js&"
import style0 from "./miniapp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports